import { get, forEach, uniq, isEmpty } from 'lodash'
import Config from '@/config'
const { imgUrl } = Config

const ru2en = (text, engToRus) => {
  var
    rus = "щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь".split(/ +/g),
    eng = "shh sh ch cz yu ya yo zh `` y' e` a b v g d e z i j k l m n o p r s t u f h `".split(/ +/g)
  ;

  var x;
  for(x = 0; x < rus.length; x++) {
    text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
    text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
  }
  return text
}

export default {
  state: {
    fetchManufacturer: false
  },
  mutations: {
    changeManufacturerStatus(state, status) {
      state.fetchManufacturer = status
    }
  },
  actions: {
    // Получаем все списки в размере 5 штук (кроме разделов (категорий))
    getFirstData ({ dispatch }) {
      return Promise.all([
        dispatch('getManufacturerData'),
        dispatch('getFilesData'),
        dispatch('getSectionData'),
        dispatch('getObjectsTypesData'),
        dispatch('getApartsData'),
        dispatch('getMaterialsData')
      ])
    },

    // Получаем список всех производителей
    getManufacturerData ({ commit, state }, { limit = 9999 } = {}) {
      const params = 'id,name_short,alternativeNames,sort_by_models'

      if (state.fetchManufacturer) {
        return []
      }

      commit('changeManufacturerStatus', true)

      return axios.post(`/web-api-2/company/all/0/${limit}/${params}`)
        .then(res => res.data)
        .then(res => res.company)
        .then(items => {

          const companies = items.map(item => {
            const aNames = get(item, 'additional_info.alternativeNames', [])
            const alternativeNames = []

            if (get(item, 'additional_info.nameFull')) {
              aNames.push(get(item, 'additional_info.nameFull'))
            }

            if (get(item, 'additional_info.nameShort')) {
              aNames.push(get(item, 'additional_info.nameShort'))
            } else {
              aNames.push(item.name_short)
            }

            forEach(aNames, altName => {
              const name = String(altName).toLowerCase()
              const engName = ru2en(name)
              const ruName = ru2en(name, true)

              alternativeNames.push(name, engName, ruName)
            })

            return {
              ...item,
              id: String(item.id),
              text: item.name_short,
              alternativeNames: uniq(alternativeNames),
              checked: false
            }
          })

          commit('getManufacturerList', companies)
          commit('changeManufacturerStatus', false)
        })
        .catch(() => {
          commit('changeManufacturerStatus', false)
          console.log('catch 123233333')
        })
    },

    // Получаем список всех файлов
    getFilesData ({ commit }) {
      return axios.get('/web-api-2/listcadext').then(res => {
        const arr = res.data.data.map(itm => ({id: itm.code, text: itm.name +` (${itm.code})`, checked: false}))
        commit('getFileList', arr)
        return arr
      })
    },

    getFilesDataWebApi () {
      return axios.get('/web-api/listcadext')
        .then(res => res.data.data)
        .catch(console.error)
    },

    // Получаем список всех объектов
    getObjectsTypesData ({ commit }) {
      return axios.get('/web-api-2/buildings/all').then(res => {
        const arr = res.data.data.map(itm => ({id: itm.code, text: itm.name, checked: false}))
        commit('getObjectsType', arr)
        return arr
      })
    },

    // Получаем список всех помещений
    getApartsData ({ commit }) {
      return axios.get('/web-api-2/rooms/all').then(res => {
        const arr = res.data.data.map(itm => ({id: itm.code, text: itm.name, checked: false}))
        commit('getAparts', arr)
        return arr
      })
    },

    // Получаем список всех материалов
    getMaterialsData ({ commit }) {
      return axios.get('/web-api-2/materials/all').then(res => {
        const arr = res.data.data.map(itm => ({id: itm.code, text: itm.name, checked: false}))
        commit('getMaterials', arr)
        return arr
      })
    },

    //  Получаем список всех разделы
    getSectionData ({ commit }) {
      return axios.get('/web-api-2/objcategory/all').then(res => {
        const arr = res.data.data.map(itm => ({id: itm.code, text: itm.name}))
        commit('getCategory', arr)
        return arr
      })
    },

    // Получаем все категории (типы)
    getTypeFromStore ({ commit }, categoryId) {
      return axios.post(
        '/web-api-2/types_list',
        { limit: 999, id_category: categoryId }
      ).then(res => {
        commit('getTypes', res.data.rows)
        return res.data.rows
      })
    },

    // Получаем все подкатегории (классы) по id категории
    getClassFromStore ({ commit }, typeId) {
      return axios.post(
        '/web-api-2/classes_list',
        { limit: 999, id_type: typeId, }
      ).then(res => {
        commit('getClasses', res.data.rows)
        return res.data.rows
      })
    },

    getClassBySearch (_ctx, search) {
      return axios
        .get(`/?a=GetCatLists&key=ext${search ? `&q=${search}` : ''}`)
        .then(response => response.data.class ? response.data.class : [])
        .catch(error => { throw error })
    },

    getMaxValuesSlider ({ commit }, values) {
      commit('maxLength', values.params[1].max)
      commit('maxWidth', values.params[2].max)
      commit('maxHeight', values.params[3].max)
      commit('maxWeight', values.params[4].max)
      commit('maxDiametr', values.params[5].max)
    },

    isLogin ({ commit }, value) {
      commit('isLogin', value)
    },

    getVipList () {
      return axios.post('/web-api-2/company_search_elastic',
        { page: 1,
          size: 30,
        })
        .then(r => {
          return r.data.items || []
        })
        .then(companies => {
          const res = companies.map(item => ({
            id: item.id,
            name_alias: item.alias,
            logo: {
              svg: imgUrl(`/images/${item.logo}`),
            },
            name_short: item.nameShort || item.nameFull
          }))

          return res
        })
        .catch(console.error)
    },
  },
  getters: {},
}
